<template>
  <div class="document-container">
    <div class="columns">
      <div class="column column-left is-three-quarters is-paddingless">
        <div class="flex-container-left">
          <div>
            <div class="document-container">
              <div class="document">
                <div class="header">
                  <es-header>
                    <template #header>
                      <div class="header-title">Customize Report: Population Data Report</div>
                    </template>
                  </es-header>
                </div>
                <div class="content">
                  <es-loader v-if="loading" style="margin: 1.5rem" />
                  <es-form v-else>
                    <template #es-form>
                      <div class="row removeUnderline">
                        <div class="field is-horizontal">
                          <div class="field-label is-normal">
                            <label
                              class="label"
                              style="width:160px"
                              aria-label="Enrollment Year(School Year)"
                            >
                              Enrollment Year(School Year)
                            </label>
                          </div>
                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <es-select
                                  key-value="id"
                                  value-tpl="${year}"
                                  @update:values="selectedSchoolYear = $event"
                                  :clearOut="true"
                                  :set-values="pidSchoolYearsDesc"
                                  :preSelected="selectedSchoolYear"
                                />
                              </div>
                              <span
                                v-if="hasErrorSchoolYear"
                                class="help is-danger"
                              >
                                {{ msgErrorSchoolYear }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </es-form>
                </div>
                <div class="es-actions">
                  <es-form-actions>
                    <template #form-actions>
                      <div class="bottom-content">
                        <ul>
                          <li class="reset">
                            <div class="list-content">
                              <a
                                :class="{ 'disable': loading }"
                                @click="$router.push('/directMatch/reports')"
                                >
                                  Cancel
                              </a>
                            </div>
                          </li>
                          <li>
                            <div class="list-content">
                              <button
                                class="button is-primary"
                                :class="{ 'disable': loading }"
                                @click="post"
                                >
                                  Generate
                              </button>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </template>
                  </es-form-actions>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column column-right is-one-quarter is-paddingless">
        <div class="flex-container-right">
          <div class="document-container">
            <div class="document" name="instructions">
              <div class="header">
                <es-header>
                  <template #header>
                    <div class="header-title">Instructions</div>
                  </template>
                </es-header>
              </div>
              <div class="tips-container has-text-left">
                <div class="tip">
                  <div class="tip-header" role="heading">
                    Enrollment Year (School Year)
                  </div>
                  <div class="tip-body">
                    Please select a valid Enrollment Year (School Year)
                    from the drop-down menu before clicking the Generate button.
                    The selection in this field will determine the data that is returned in the report.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';

import 'vue-popperjs/dist/vue-popper.css';

import EsForm from '@/components/EsForm.vue';
import EsFormActions from '@/components/EsFormActions.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsSelect from '@/components/EsSelect.vue';

import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import NotificationManager from '@/mixins/NotificationManager';

export default {
  mixins: [BreadcrumbsManager, NotificationManager],
  created() {
    this.setBreadcrumbs();
  },
  mounted() {
    this.loadPidSchoolYears();
  },
  components: {
    EsForm,
    EsFormActions,
    EsHeader,
    EsLoader,
    EsSelect,
  },
  data() {
    return {
      reportType: 'DM_POPULATION',
      formErrorMsg: 'There were some errors. Please try again. If errors persist please contact support.',
      selectedSchoolYear: null,
      hasErrorSchoolYear: false,
      msgErrorSchoolYear: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters('lookups', [
      'pidSchoolYearsDesc',
    ]),
  },
  methods: {
    ...mapActions('lookups', [
      'loadPidSchoolYears',
    ]),
    setBreadcrumbs() {
      this.setBreadcrumb([
        { text: 'Home', to: { name: 'directMatch' } },
        { text: 'Reports', to: { name: 'reportsmaind' } },
        { text: 'Population Data Report', to: {} },
      ]);
    },
    async post() {
      if (!this.checkRequiredFields()) {
        return;
      }

      try {
        this.loading = true;
        await axios.post('/reports/', ({
          reportType: this.reportType,
          schoolYear: this.selectedSchoolYear[0].year,
        }));
        this.$router.push({ path: '/directMatch/reports', query: { showSuccessMessage: true } });
      } catch (err) {
        this.showNotification('danger', [this.formErrorMsg]);
      } finally {
        this.loading = false;
      }
    },
    checkRequiredFields() {
      this.resetErrors();
      if (!this.selectedSchoolYear || !this.selectedSchoolYear.length) {
        this.hasErrorSchoolYear = true;
        this.msgErrorSchoolYear = 'Enrollment Year(School Year) is required.';
        this.showNotification('danger', ['There were some errors. Please fix the errors highlighted in the fields below.']);
        return false;
      }
      return true;
    },
    resetErrors() {
      this.hasErrorSchoolYear = false;
      this.msgErrorSchoolYear = null;
      this.$store.state.notifications.isActive = false;
      this.$store.state.notifications.notificationType = null;
    },
  },
};
</script>

<style lang="sass" scoped>
  .disable
    pointer-events: none
    text-decoration: none
    opacity: 0.25
    color: #999
  .tips-container
    padding: 1rem
    font-size: 12px
  .tip
    margin-bottom: 1rem
    &:last-child
      margin-bottom: 0
  .tip-header
    font-weight: bold
    padding-bottom: 0.5rem
  .tip-body
    margin-bottom: 0.5rem
    &:last-child
      margin-bottom: 0
</style>
